export function sortByName(a, b) {
  if (a.name.normalize('NFD') > b.name.normalize('NFD')) {
    return 1;
  }

  if (b.name.normalize('NFD') > a.name.normalize('NFD')) {
    return -1;
  }

  return 0;
}
